define('modules/form_editor/views/editor_checkgroup',['require','exports','module','base/collectionview','ldsh!../templates/editor_check_radio','./editor_checkradio_item'],function(require, exports, module){
  "use strict";
  var CollectionView = require("base/collectionview");
  module.exports = CollectionView.extend({
    template: require("ldsh!../templates/editor_check_radio"),
    itemContainer: ".js-items",
    itemView: require("./editor_checkradio_item"),

    initialize: function() {
      this.collection = this.model.items;
      this.listenTo(this.childVent, "item:add", this.addNewItem);
      this.listenTo(this.childVent, "item:remove", this.removeItem);
    },

    //add a new item to the collection, after the "model"
    addNewItem: function(view){
      this.model.addItemAfter(view.model);
    },

    //remove this model
    removeItem: function(view){
      this.model.removeItem(view.model);
    },

    onRender: function(){
      this.$el.i18n();
    }
  });
});

